import type { Editor } from '@tiptap/core'
import { getMarkRange } from '@tiptap/core'

import { sanitizeUrl } from '@/lib/tiptap-utils'

export type CaretLink = {
  href: string
  element: HTMLAnchorElement
}

const SCHEME_RE = /^[a-z][a-z0-9+.-]*:/i

/** キャレット（範囲選択でない）がリンク内にあれば、その href と描画中の <a> 要素を返す */
export function getCaretLink(editor: Editor): CaretLink | null {
  if (!editor.isEditable) return null
  const { selection, schema } = editor.state
  if (!selection.empty) return null
  const linkType = schema.marks.link
  if (!linkType) return null

  const range = getMarkRange(selection.$from, linkType)
  if (!range) return null
  const href: unknown = editor.state.doc.nodeAt(range.from)?.marks.find((mark) => mark.type === linkType)?.attrs.href
  if (typeof href !== 'string' || !href) return null

  const { node } = editor.view.domAtPos(range.from + 1)
  const parent = node instanceof Element ? node : node.parentElement
  const element = parent?.closest('a')
  if (!element || !editor.view.dom.contains(element)) return null
  return { href, element }
}

/** 新しいタブで開ける URL にする。スキームの無い `example.com` はアプリ内の相対パスにせず https を補う */
export function toOpenableUrl(href: string): string | null {
  const trimmed = href.trim()
  const withScheme = SCHEME_RE.test(trimmed) || /^[/#?]/.test(trimmed) ? trimmed : `https://${trimmed}`
  const safe = sanitizeUrl(withScheme, window.location.href)
  return safe === '#' ? null : safe
}
